<template lang="es">
    <v-container>
      <v-row>
        <v-col cols="12" sm="6" class="text-center">
          <v-card class="pa-4">
            <v-card-title class="headline mb-4">Tensión</v-card-title>
            <v-card-subtitle class="body-1 font-weight-bold" style="font-size: 24px; color: #1976D2;">
              {{ tension || 'Cargando...' }}
            </v-card-subtitle>
          </v-card>
        </v-col>
  
        <v-col cols="12" sm="6" class="text-center">
          <v-card class="pa-4">
            <v-card-title class="headline mb-4">Corriente</v-card-title>
            <v-card-subtitle class="body-1 font-weight-bold" style="font-size: 24px; color: #388E3C;">
              {{ corriente || 'Cargando...' }}
            </v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card>
            <v-card-text>
              <v-card>
                <v-card-text class="mb-2">
                  <v-row>
                    <v-col
                      cols="12"
                      md="5"
                    >
                      <koiote-date-picker
                        dateLabel="Fecha Inicio"
                        hourLabel="Hora Inicio"
                        :type="1"
                      ></koiote-date-picker>
                    </v-col>
                    <v-col
                      cols="12"
                      md="5"
                    >
                      <koiote-date-picker
                        dateLabel="Fecha Fin"
                        hourLabel="Hora Fin"
                        :type="2"
                      ></koiote-date-picker>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                      class="d-flex align-self-center"
                    >
                      <!-- <v-btn
                        block
                        @click="addDataToVariable(1)"
                      >
                        Buscar
                      </v-btn> -->
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
        <!-- <FiltroAnalizador @respuesta="obtener"></FiltroAnalizador> -->
        <v-row>
          <!-- Selector de variables -->
          <v-col cols="3" class="sidebar">
            <v-card class="scrollable-card">
              <v-card-title>Seleccionar variables</v-card-title>
              <v-card-text>
                <v-list>
                  <v-list-item-group
                    v-model="selected_variables"
                    multiple
                    color="blue"
                    @change="addDataToVariable(2)"
                  >
                    <v-list-item
                      v-for="(item, index) in available_variables"
                      :key="index"
                      :value="item.value"
                      :label="item.text"
                    >
                      <v-list-item-title class="body-2">{{ item.text }}</v-list-item-title>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- Gráfico -->
          <v-col cols="9">
            <v-progress-linear
              v-if="loading"
              indeterminate
              color="primary"
            ></v-progress-linear>

            <line-chart
              v-if="chart_data && !loading"
              :chart-data="chart_data"
            ></line-chart>
          </v-col>
        </v-row>

        <!-- Resultados abajo -->
        <DatosAnalizador :datos="table_data" :headers="table_headers" />
    </v-container>
  </template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import moment from 'moment-timezone';

import KoioteDatePicker from "@/components/utils/KoioteDatePicker.vue";
import FiltroAnalizador from "@/components/forms/FiltroAnalizador.vue";
import DatosAnalizador from "@/components/forms/DatosAnalizador.vue";
import LineChart from "@/components/LineChart.vue";
export default {
    components: { DatosAnalizador,FiltroAnalizador, LineChart, KoioteDatePicker},
    data() {
        return {
            tension: null,
            corriente: null,
            potencia: null,

            datos: [],

            table_headers: [],
            table_data:[],

            chart_data: null,

            loading: false,

            selected_variables: [],

            analizador_num: null,
        }
    },
    created(){
      this.analizador_num = this.$route.params.analizador_num;
    },
    computed: {
        ...mapState("nodered", ["client"]),
        computed_chart_data(){

        },
        // analizador_num() {
        //   return this.$route.params.analizador_num;
        // },
        available_variables() {
          const prefix = this.analizador_num === "2" ? "CVM-B150" : "CVMB150";
          return [
            { text: "Tensión fase – neutro (VI1)", value: `${prefix}.VI1` },
            { text: "Tensión fase – neutro (VI2)", value: `${prefix}.VI2` },
            { text: "Tensión fase – neutro (VI3)", value: `${prefix}.VI3` },
            { text: "Tensión fase – neutro (VI)", value: `${prefix}.VI` },

            { text: "Tensión fase – fase (VI12)", value: `${prefix}.VI12` },
            { text: "Tensión fase – fase (VI23)", value: `${prefix}.VI23` },
            { text: "Tensión fase – fase (VI31)", value: `${prefix}.VI31` },
            { text: "Tensión fase – fase (VI123)", value: `${prefix}.VI123` },

            { text: "Corriente instantánea (AI1)", value: `${prefix}.AI1` },
            { text: "Corriente instantánea (AI2)", value: `${prefix}.AI2` },
            { text: "Corriente instantánea (AI3)", value: `${prefix}.AI3` },
            { text: "Corriente instantánea (AI)", value: `${prefix}.AI` },

            { text: "Frecuencia (HZI)", value: "HZI" },

            { text: "Potencia aparente (VAI1)", value: `${prefix}.VAI1` },
            { text: "Potencia aparente (VAI2)", value: `${prefix}.VAI2` },
            { text: "Potencia aparente (VAI3)", value: `${prefix}.VAI3` },
            { text: "Potencia aparente (VAI)", value: `${prefix}.VAI` },

            { text: "Potencia activa (API1)", value: `${prefix}.API1` },
            { text: "Potencia activa (API2)", value: `${prefix}.API2` },
            { text: "Potencia activa (API3)", value: `${prefix}.API3` },
            { text: "Potencia activa (API)", value: `${prefix}.API` },

            { text: "Potencia inductiva (IPI1)", value: `${prefix}.IPI1` },
            { text: "Potencia inductiva (IPI2)", value: `${prefix}.IPI2` },
            { text: "Potencia inductiva (IPI3)", value: `${prefix}.IPI3` },
            { text: "Potencia inductiva (IPI)", value: `${prefix}.IPI` },

            { text: "Factor de potencia (PFI1)", value: `${prefix}.PFI1` },
            { text: "Factor de potencia (PFI2)", value: `${prefix}.PFI2` },
            { text: "Factor de potencia (PFI3)", value: `${prefix}.PFI3` },
            { text: "Factor de potencia (PFI)", value: `${prefix}.PFI` },

            { text: "Energía activa (AE)", value: `${prefix}.AE` }
          ];
        }

    },
    methods: {
        ...mapActions("nodered", ["doSubscribe", "doUnsubscribe","createConnection"]),
        ...mapActions(["getAnalizerData"]),
        ...mapGetters("utils", ["getInitDateFilter", "getEndDateFilter"]),

        obtener(respuesta){
            console.log("respuesta")
            console.log(respuesta)
            this.datos = respuesta;
            // console.log(this.transformData(this.datos));
        },
        transformData(data){
          return {
              labels: data.map(entry => {
                const dt = entry.dateTime;
                // Parsear la fecha en formato UTC
                const utcMoment = moment.utc(dt, "DDMMYYYYHHmm");
                
                // Convertir a hora local española (maneja CET/CEST automáticamente)
                const localMoment = utcMoment.tz("Europe/Madrid");
                
                // Formatear como "YYYY-MM-DD HH:mm"
                return localMoment.format("YYYY-MM-DD HH:mm");
              }),
              datasets: [
                {
                  label: data[0].field.id,
                  data: data.map(entry => parseFloat(entry.field.value)),
                  borderColor: `rgba(${Math.floor(Math.random() * 256)},${Math.floor(Math.random() * 256)},${Math.floor(Math.random() * 256)},0.4)`,
                  backgroundColor: `rgba(${Math.floor(Math.random() * 256)},${Math.floor(Math.random() * 256)},${Math.floor(Math.random() * 256)},0.4)`,
                  fill: true,
                  tension: 0.1,
                }
              ]
            };
        },

        formattedDate(date){
          const d = new Date(date);
          const year = d.getFullYear();
          const month = String(d.getMonth() + 1).padStart(2, '0');
          const day = String(d.getDate()).padStart(2, '0');
          const hours = String(d.getHours()).padStart(2, '0');
          const minutes = String(d.getMinutes()).padStart(2, '0');
          const seconds = String(d.getSeconds()).padStart(2, '0');
          return `${day}${month}${year}${hours}${minutes}${seconds}`;
        },

        async addDataToVariable(origin) {
          this.loading = true;
          if (origin === 1) {
            this.chart_data = {};
            this.table_data = [];
          }

          const params = {
            variables: this.selected_variables,
            initDate: this.formattedDate(this.getInitDateFilter()),
            endDate: this.formattedDate(this.getEndDateFilter()),
          };

          let datasets = [];
          let labels = [];

          //recogemos los datos de cada variable en el tiempo dado
          for(let variable of params.variables){
            const output = {
              var: variable,
              begin: params.initDate,
              end: params.endDate,
              ip: this.analizador_num == 1 ? "176" : "177"
            };
            const payload = {
              path:'get-xml',
              params: output
            }
    
            const data = await this.getAnalizerData(payload);
            const record = data.recordGroup.record;

            this.datos = record;
            datasets.push(this.transformData(record).datasets[0]);
            labels = this.transformData(record).labels
          };

          this.chart_data = {
            datasets: datasets,
            labels: labels
          }
          this.loading = false;
          // console.log(this.chart_data);
          
          //Crear cabeceras de la table
          this.table_headers = [
            { text: "Fecha", value: "date" },
            ...this.chart_data.datasets.map((data) => ({
              text: data.label,
              value: data.label
            }))
          ];

          //Crear el array de datos para mostrar en la tabla
          this.table_data = this.chart_data.labels.map((label, index) => {
            const row = { date: label };

            this.chart_data.datasets.forEach((dataset) => {
              row[dataset.label] = dataset.data[index];
            });

            return row;
          });
        },
        
       
    },
    beforeDestroy() {
      this.doUnsubscribe(`tension_circutor_${this.analizador_num}`);
      this.doUnsubscribe(`corriente_circutor_${this.analizador_num}`);
      this.doUnsubscribe(`potencia_circutor_${this.analizador_num}`);
    },

    watch: {
        "client.connected": function(newVal, oldVal) {
        if (newVal) {
            console.log("Cliente MQTT conectado");
            this.doSubscribe(`tension_circutor_${this.analizador_num}`);
            this.doSubscribe(`corriente_circutor_${this.analizador_num}`);
            this.doSubscribe(`potencia_circutor_${this.analizador_num}`);
            this.client.on("message", (topic, message) => {
              
                if( topic == `tension_circutor_${this.analizador_num}`) {
                    this.tension = message;
                }
                if( topic == `corriente_circutor_${this.analizador_num}`) {
                    this.corriente = message;
                }
                if( topic == `potencia_circutor_${this.analizador_num}`) {
                    this.potencia = message;
                }
            });
            // Realiza acciones cuando el cliente se conecta, si es necesario
        } else {
            
            console.log("Cliente MQTT desconectado");
            // Realiza acciones cuando el cliente se desconecta, si es necesario
        }
        },
    },

  

    mounted() {
        this.createConnection()

        // this.getAnalizerData('get-xml')
    
   
        // this.client.on("message", (topic, message) => {
        //     console.log("ha llegado mensaje!", topic,)
        // });
      
    },
}
</script>
<style lang="">
    
</style>